import React from 'react';
import './New.css'

function New() {
    return (
      <div className="quote">
      
      </div>
    );
  }
  
  export default New;